export default __webpack_public_path__ + "static/media/status.9bd0604f.svg";